import { render, staticRenderFns } from "./PrismEditor.vue?vue&type=template&id=7dfce64b"
import script from "./PrismEditor.vue?vue&type=script&lang=js"
export * from "./PrismEditor.vue?vue&type=script&lang=js"
import style0 from "./PrismEditor.vue?vue&type=style&index=0&id=7dfce64b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports